export default function CsharpVirtualOverride() {
  return (
    <h2>Csharp Virtual Override</h2>
  );
}
